import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectDocumentState } from '../../../store/interface/interface.state';
import { DocumentStateEnum } from '../../../enum/document-state.enum';
import { map } from 'rxjs/operators';
import { MatTooltip } from '@angular/material/tooltip';
import { IconComponent } from '../../shared/icon/icon.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-document-indicator',
    templateUrl: './document-indicator.component.html',
    styleUrls: ['./document-indicator.component.scss'],
    imports: [IconComponent, MatTooltip, AsyncPipe]
})
export class DocumentIndicatorComponent implements OnInit {

    display$: Observable<boolean>;

    constructor(private store: Store<AppState>) {
        this.display$ = store.select(selectDocumentState).pipe(
            map((state) => state !== DocumentStateEnum.NONE)
        );
    }

    ngOnInit(): void {
    }

}
